import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Select, MenuItem, FormControl } from '@mui/material';
import * as Actions from '../../actions/actions';

const DoorDetailsGridPanel = ({ allDoorDetailsData, filters, ...props }) => {

    // Always derive door options from the full unfiltered dataset
    const allDoors = useMemo(() => {
        if (!allDoorDetailsData || allDoorDetailsData.length === 0) return [];
        return [...new Set(allDoorDetailsData.map(row => row.door_name).filter(Boolean))].sort();
    }, [allDoorDetailsData]);

    const filteredData = useMemo(() => {
        if (!allDoorDetailsData || allDoorDetailsData.length === 0) return [];
        if (filters.door) {
            return allDoorDetailsData.filter(row => row.door_name === filters.door);
        }
        return allDoorDetailsData;
    }, [allDoorDetailsData, filters.door]);

    const columns = [
        { field: 'door_name', headerName: 'Door', width: 120 },
        { field: 'rfid', headerName: 'RFID', width: 180 },
        { field: 'sscc', headerName: 'SSCC', width: 150 },
        { field: 'sscc_local_route', headerName: 'Pallet Route', width: 140 },
        { field: 'dock_door_local_route', headerName: 'Door Route', width: 140 },
        { field: 'transaction_date_time', headerName: 'Scan Time', width: 200 },
        { field: 'movement_type', headerName: 'Movement Type', width: 140 },
        { field: 'is_wrong_route', headerName: 'Wrong Route', width: 130, type: 'boolean' }
    ];

    const handleDoorFilterChange = (event) => {
        props.updateFilters('door', event.target.value);
    };

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: "100%" }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>DOOR-CENTRIC DETAILS</h3>
                </div>
                <div style={{ padding: '15px 20px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                    <FormControl sx={{ width: 250, backgroundColor: 'white' }} size="small">
                        <Select
                            value={filters.door || ''}
                            onChange={handleDoorFilterChange}
                            displayEmpty
                            renderValue={(selected) => selected || 'All Doors'}
                        >
                            <MenuItem value="">All Doors</MenuItem>
                            {allDoors.map((door) => (
                                <MenuItem key={door} value={door}>{door}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="duolift-device-detail-card-body">
                    <div style={{ height: '440px', width: '100%' }}>
                        <DataGrid
                            rows={filteredData}
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            paginationMode="client"
                            getRowId={(row) => row.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    allDoorDetailsData: state.loadValidationDashboard.doorDetailsData,
    filters: state.loadValidationDashboard.filters
});

const mapDispatchToProps = (dispatch) => ({
    updateFilters: (filterType, value) => dispatch(Actions.UPDATE_LVD_FILTERS(filterType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(DoorDetailsGridPanel);
